// extracted by mini-css-extract-plugin
export default {"ssoConfirmation":"ssoConfirmation__ciFMJ"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"ssoConfirmation\":\"ssoConfirmation__ciFMJ\"}";
        // 1787130557005
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  